"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContextWithHook = void 0;
const react_1 = require("react");
const createContextWithHook = (hook) => {
    const Context = (0, react_1.createContext)(null);
    return {
        Context,
        Provider: ({ children, ...props }) => (0, react_1.createElement)(Context.Provider, { value: hook && hook(props) }, children),
    };
};
exports.createContextWithHook = createContextWithHook;
//# sourceMappingURL=react.js.map